module.exports = __webpack_public_path__ + "img/login.b382d25e.png";